export default function(error) {
  let isAccessDenied = false;

  if (!error.graphQLErrors || !error.graphQLErrors.length) {
    return false;
  }

  error.graphQLErrors.forEach(({ name }) => {
    if (name === 'ACCESS_DENIED') {
      isAccessDenied = true;
    }
  });

  return isAccessDenied;
}



// WEBPACK FOOTER //
// ./src/helpers/checkIsAccessDenied.js